import React from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';
import { companyInfo } from '../data/mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-6 lg:px-12 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_merx-landing/artifacts/b5dmjfew_MERX%20LOGO%20PNG.png"
              alt="MERX Consultoria Logo"
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-sm leading-relaxed text-gray-400">
              Expertos en limpieza profesional. Transformando espacios en ambientes 
              impecables y saludables desde 2023.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-base mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              {[
                { label: 'Inicio', id: 'hero' },
                { label: 'Servicios', id: 'services' },
                { label: 'Metodología', id: 'methodology' },
                { label: 'Sobre Nosotros', id: 'about' }
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-sm text-gray-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="text-white font-semibold text-base mb-4">Servicios</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Limpieza de Inmuebles</li>
              <li>Limpieza Post-Construcción</li>
              <li>Desinfección Profesional</li>
              <li>Limpieza de Fachadas</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold text-base mb-4">Contacto</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <Mail size={16} className="text-[#2E75B6] mt-0.5 flex-shrink-0" />
                <a 
                  href={`mailto:${companyInfo.email}`}
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  {companyInfo.email}
                </a>
              </div>
              <div className="flex items-start gap-3">
                <Phone size={16} className="text-[#2E75B6] mt-0.5 flex-shrink-0" />
                <a 
                  href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  {companyInfo.phone}
                </a>
              </div>
              <div className="flex items-start gap-3">
                <MapPin size={16} className="text-[#2E75B6] mt-0.5 flex-shrink-0" />
                <p className="text-sm text-gray-400 leading-relaxed">
                  Zapopan, Jalisco, México
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
            <p>
              © {currentYear} MERX CONSULTORIA. Todos los derechos reservados.
            </p>
            <div className="flex gap-6">
              <button className="hover:text-gray-300 transition-colors">
                Política de Privacidad
              </button>
              <button className="hover:text-gray-300 transition-colors">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
